const flyerMappingData = [
    {
        value: 'GF',
        label: 'Flyer',
        bg: '#d45355',
        color: '#f9f9f9',
        url: 'https://accelery-files.s3.eu-central-1.amazonaws.com/GF_Flyer.png'
    },
    {
        value: 'MM',
        label: 'Flyer',
        bg: '#d0e5de',
        color: '#121212',
        url: 'https://accelery-files.s3.eu-central-1.amazonaws.com/Muckelclub.jpg'
    },
    {
        value: '#BP',
        label: 'Flyer',
        bg: '#EBE2D2',
        color: '#121212',
        url: 'https://accelery-files.s3.eu-central-1.amazonaws.com/Bo%26Birdie.JPG'
    },
    {
        value: '#FW',
        label: 'Flyer',
        bg: '#E17D63',
        color: '#f9f9f9',
        url: 'https://accelery-files.s3.eu-central-1.amazonaws.com/FamWalls.JPG'
    },
    {
        value: 'TONI',
        label: 'Flyer',
        bg: '#86D2DC',
        color: '#f9f9f9',
        url: 'https://cdn.shopify.com/s/files/1/0817/0042/1971/files/Toni.jpg?v=1761032709'
    },
    {
        value: 'ACRYL',
        label: 'Flyer',
        bg: '#86D2DC',
        color: '#f9f9f9',
        url: 'https://accelery-files.s3.eu-central-1.amazonaws.com/Acryl.jpg'
    },
    {
        value: 'SPARDOSE',
        label: 'Flyer',
        bg: '#86D2DC',
        color: '#f9f9f9',
        url: 'https://accelery-files.s3.eu-central-1.amazonaws.com/Spardose.jpg'
    }
]

export default flyerMappingData;